import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatListModule} from "@angular/material/list";
import {MatIconModule} from "@angular/material/icon";
import {MatSelectModule} from "@angular/material/select";
import {MatInputModule} from "@angular/material/input";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatDividerModule} from "@angular/material/divider";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {MatTableModule} from "@angular/material/table";
import {MatSortModule} from "@angular/material/sort";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatButtonModule} from "@angular/material/button";
import {ClipboardModule} from "@angular/cdk/clipboard";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatCardModule} from "@angular/material/card";
import {MatTabsModule} from "@angular/material/tabs";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from "ngx-perfect-scrollbar";
import {MatRadioModule} from "@angular/material/radio";
import {ConfirmActionComponent} from './modals/confirm-action/confirm-action.component';
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatTooltipModule} from "@angular/material/tooltip";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {NgxChartsModule} from "@swimlane/ngx-charts";
import {MatMenuModule} from "@angular/material/menu";
import {ReasonComponent} from './modals/reason/reason.component';
import {FastCoinToDollarPipe} from "../@core/pipes/fastcoin-to-dollar.pipe";
import {FilterTextPipe} from "../@core/pipes/filter-text.pipe";
import {CountDownModule} from "./count-down/count-down.module";
import {CeilPipe} from "../@core/pipes/ceil.pipe";
import {CustomCurrencyPipe} from "../@core/pipes/custom-currency.pipe";
import {LogDataReasonPipe} from "../@core/pipes/log-data-reason.pipe";
import {MatSidenavModule} from "@angular/material/sidenav";
import {ModalWindowComponent} from './modal-window/modal-window.component';
import {EnumToArrayPipe} from "../@core/pipes/enumToArray.pipe";
import {NgxMatDatetimePickerModule} from "@angular-material-components/datetime-picker";
import {CdkTreeModule} from "@angular/cdk/tree";
import {HashPipe} from "../@core/pipes/hash.pipe";
import { FreeCasesComponent } from './free-cases/free-cases.component';
import {RouterModule} from "@angular/router";
import { ShopItemsComponent } from './shop-items/shop-items.component';
import { ConfirmComponent } from './modals/confirm/confirm.component';
import {MatDialogModule} from "@angular/material/dialog";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [
    ConfirmActionComponent,
    ReasonComponent,
    FastCoinToDollarPipe,
    CustomCurrencyPipe,
    LogDataReasonPipe,
    FilterTextPipe,
    CeilPipe,
    HashPipe,
    EnumToArrayPipe,
    ModalWindowComponent,
    FreeCasesComponent,
    ShopItemsComponent,
    ConfirmComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatListModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MatDividerModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatButtonModule,
    ClipboardModule,
    MatProgressBarModule,
    MatCardModule,
    MatTabsModule,
    MatCheckboxModule,
    PerfectScrollbarModule,
    MatSnackBarModule,
    MatTooltipModule,
    ScrollingModule,
    NgxChartsModule,
    MatMenuModule,
    CountDownModule,
    MatSidenavModule,
    NgxMatDatetimePickerModule,
    CdkTreeModule,
    RouterModule,
    MatDialogModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatListModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MatDividerModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatButtonModule,
    ClipboardModule,
    MatProgressBarModule,
    MatCardModule,
    MatTabsModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatSnackBarModule,
    MatTooltipModule,
    ScrollingModule,
    NgxChartsModule,
    MatMenuModule,
    FastCoinToDollarPipe,
    CustomCurrencyPipe,
    LogDataReasonPipe,
    FilterTextPipe,
    CountDownModule,
    CeilPipe,
    HashPipe,
    MatSidenavModule,
    ModalWindowComponent,
    EnumToArrayPipe,
    NgxMatDatetimePickerModule,
    CdkTreeModule
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class SharedModule {
}
